import { render, staticRenderFns } from "./Submissions.vue?vue&type=template&id=5dec7c8d"
import script from "./Submissions.vue?vue&type=script&lang=js"
export * from "./Submissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dec7c8d')) {
      api.createRecord('5dec7c8d', component.options)
    } else {
      api.reload('5dec7c8d', component.options)
    }
    module.hot.accept("./Submissions.vue?vue&type=template&id=5dec7c8d", function () {
      api.rerender('5dec7c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/front_user_account/Submissions.vue"
export default component.exports